<div class="mt-4">
  <div class="p-2 text-center ">
    <div class="container lh-sm">
<!--      <span class="fs-2  fw-medium ">Asistencia médica</span>-->
      <br>
      <span class="fs-2 fw-bold">Sin salir de casa u oficina</span>
      <div class="row row-cols-1 row-cols-sm-2 d-flex justify-content-center row-cols-md-3 row-cols-lg-4 g-4 py-5">
        <div *ngFor="let service of services; let i = index" class="col d-flex align-items-start">
          <img ngSrc="assets/img/movilink/{{service.imagen}}" alt="{{ service.nombre }} Logo" class=" flex-shrink-0" height="16" width="16">
          <div>
            <span class="px-2 mb-0 fs-5 text-secondary">{{ service.nombre }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
